@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-row w-full justify-between">
      @if (field.browserOpts.inLineWithCaption) {
        <mat-label class="mr-2 mb-4 font-medium">
          {{ field.label | localize }}
        </mat-label>
      }
      <mat-form-field class="w-full">
        @if (!field.browserOpts.inLineWithCaption) {
          <mat-label>{{ field.label | localize }}</mat-label>
        }
        <input matInput [formControl]="field.control" [min]="min" [max]="max" [matDatepicker]="datepicker" (click)="openDatepickerOnClick(datepicker)"
          (dateChange)="dateChange($event)" [readonly]="field.readonly" [required]="field.required" />
          <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
          <mat-datepicker #datepicker [startView]="remote ? 'multi-year' : 'month'"></mat-datepicker>
          @if (field.hint) {
            <mat-hint>{{ field.hint | localize }}</mat-hint>
          }
          @if (!field.readonly) {
            <mat-error>
              @if (field.control.hasError('required')) {
                {{ 'dateRequired' | transloco }}
              }
              @if (field.control.hasError('dateMax') || field.control.hasError('matDatepickerMax')) {
                {{ 'dateLessThan' | transloco:{ date: (field.max | localizeDate: 'dd/MM/yyyy') } }}
              }
              @if (field.control.hasError('dateMin') || field.control.hasError('matDatepickerMin')) {
                {{ 'dateGreaterThan' | transloco:{ date: (field.min | localizeDate: 'dd/MM/yyyy') } }}
              }
              @if (field.control.hasError('conditionalDateMax')) {
                {{ 'dateLessThan' | transloco:{ date: (field.control.errors.conditionalDateMax.dateMax | localizeDate: 'dd/MM/yyyy') } }}
              }
              @if (field.control.hasError('conditionalDateMin')) {
                {{ 'dateGreaterThan' | transloco:{ date: (field.control.errors.conditionalDateMin.dateMin | localizeDate: 'dd/MM/yyyy') }  }}
              }
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
  } @else {
    @switch (style) {
      @case ('SHORT') {
        {{ field.control.value | date:'dd/MM/yyyy' }}
      }
      @case ('MEDIUM') {
        {{ field.control.value | date:'dd MMM yyyy' }}
      }
      @case ('LONG') {
        {{ field.control.value | date:'dd MMMM yyyy' }}
      }
      @case ('FULL') {
        {{ field.control.value | date:'EEE, dd MMMM yyyy' }}
      }
    }
  }

